import {EnvironmentalClaimType} from "../../definitions/types";

export class EnvironmentalClaimModel {
    private readonly _environmentalClaim: EnvironmentalClaimType;

    constructor(public readonly environmentalClaim: EnvironmentalClaimType) {
        this._environmentalClaim = environmentalClaim;
    }

    /**
     * @method id
     * @description Returns the id of the environmental claim.
     * @returns {number}
     */
    public get id(): number {
        return this._environmentalClaim.id;
    }

    /**
     * @method productId
     * @description Returns the id of the product that the environmental claim is associated with.
     * @returns {number}
     */
    public get productId(): number {
        return this._environmentalClaim.productId;
    }

    /**
     * @method sku
     * @description Returns the sku of the product that the environmental claim is associated with.
     * @returns {string}
     */
    public get sku(): string {
        return this._environmentalClaim.sku;
    }

    /**
     * @method name
     * @description Returns the description of the environmental claim.
     * @returns {string}
     */
    public get description(): string {
        return this._environmentalClaim.description;
    }
}